import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

export type ArchiveAction = 'archive' | 'unarchive';

const TEXTS: Record<ArchiveAction, { title: string; confirmButtonText: string; message: string }> = {
    archive: {
        title: 'Archive template?',
        confirmButtonText: 'Archive',
        message: 'will be added to the archive.',
    },
    unarchive: {
        title: 'Unarchive template?',
        confirmButtonText: 'Unarchive',
        message: 'will be moved back to the active templates.',
    },
};

type Props = {
    open: boolean;
    action: ArchiveAction;
    templateName?: string;
    onCancel: () => void;
    onConfirm: () => void;
};

const ArchiveItemFieldTemplateModal = ({ open, action, templateName, onCancel, onConfirm }: Props) => {
    const { title, confirmButtonText, message } = TEXTS[action];

    return (
        <ConfirmationModal
            width={500}
            title={title}
            confirmButtonText={confirmButtonText}
            icon={<ContainerOutlined />}
            content={
                <Typography.Text>
                    "{templateName}" {message}
                </Typography.Text>
            }
            open={open}
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    );
};

export default ArchiveItemFieldTemplateModal;
